import { useState } from 'react';
import { FaLock } from 'react-icons/fa';

export default function ProtectedInterview({ children }) {
    const existingPassword = localStorage.getItem("interview-pass");
    const [accessGranted, setAccessGranted] = useState(false);
    const [password, setPassword] = useState("");
    const [newPass, setNewPass] = useState("");
    const [showChange, setShowChange] = useState(false);

    const handleCreatePassword = (e) => {
        e.preventDefault();
        if (!newPass) return alert("Password cannot be empty");
        localStorage.setItem("interview-pass", newPass);
        alert("✅ Password created successfully!");
        setNewPass("");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === existingPassword) {
            setAccessGranted(true);
        } else {
            alert("❌ Incorrect password");
        }
    };

    const handleChangePassword = (e) => {
        e.preventDefault();
        if (!newPass) return alert("Password cannot be empty");
        localStorage.setItem("interview-pass", newPass);
        alert("✅ Password changed successfully!");
        setNewPass("");
        setShowChange(false);
    };

    const handleResetPassword = () => {
        if (window.confirm("Are you sure you want to reset the password?")) {
            localStorage.removeItem("interview-pass");
            alert("Password reset. Please create a new password.");
            window.location.reload();
        }
    };

    if (accessGranted) return children;

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
        }}>
            <div style={{
                background: "white",
                padding: "30px 40px",
                borderRadius: "12px",
                boxShadow: "0 0 25px rgba(0,0,0,0.1)",
                textAlign: "center",
                width: "100%",
                maxWidth: "400px"
            }}>
                <div style={{ fontSize: "32px", color: "#4285F4", marginBottom: "10px" }}>
                    <FaLock />
                </div>
                <h2 style={{ marginBottom: "20px" }}>
                    {existingPassword ? "Password Required" : "Create Password"}
                </h2>

                {!existingPassword ? (
                    <form onSubmit={handleCreatePassword}>
                        <input
                            type="password"
                            placeholder="Create new password"
                            value={newPass}
                            onChange={(e) => setNewPass(e.target.value)}
                            style={inputStyle}
                        />
                        <button type="submit" style={buttonStyle("#28a745")}>
                            Create Password
                        </button>
                    </form>
                ) : (
                    <>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={inputStyle}
                            />
                            <button type="submit" style={buttonStyle("#4285F4")}>
                                Submit
                            </button>
                        </form>

                        <p style={{ marginTop: "15px", fontSize: "14px" }}>
              <span
                  onClick={() => setShowChange(!showChange)}
                  style={{
                      color: "#007bff",
                      cursor: "pointer",
                      textDecoration: "underline",
                      marginRight: "15px"
                  }}
              >
                Change Password
              </span>
                            |
                            <span
                                onClick={handleResetPassword}
                                style={{
                                    color: "crimson",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    marginLeft: "15px"
                                }}
                            >
                Reset Password
              </span>
                        </p>

                        {showChange && (
                            <form onSubmit={handleChangePassword} style={{ marginTop: "15px" }}>
                                <input
                                    type="text"
                                    placeholder="New password"
                                    value={newPass}
                                    onChange={(e) => setNewPass(e.target.value)}
                                    style={inputStyle}
                                />
                                <button type="submit" style={buttonStyle("#e67e22")}>
                                    Save New Password
                                </button>
                            </form>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

const inputStyle = {
    padding: "10px",
    fontSize: "16px",
    width: "100%",
    marginBottom: "15px",
    borderRadius: "5px",
    border: "1px solid #ccc"
};

const buttonStyle = (color) => ({
    padding: "10px",
    width: "100%",
    background: color,
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer"
});
